
import {getRandomInteger} from "kistenkonfigurator/build/util/util";
import Vue from "vue";
import {Question, questionPool} from "../../model/shared/captcha/Question";

interface State {
  questionIndex: number;
  currentQuestion: Question;
  isNothingSelected: boolean;

  answerText: string;
}

interface CaptchaQuestionState {
  questionId: number;
  answer: string;
}

export default Vue.extend({
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data(): State {
    const questionIndex = getRandomInteger(Math.random, 0, questionPool.length - 1);
    return {
      questionIndex,
      currentQuestion: questionPool[questionIndex],
      answerText: "",
      isNothingSelected: false,
    };
  },
  computed: {
    modelVar: {
      set(value: CaptchaQuestionState) {
        this.$emit("input", value);
      },
      get(): CaptchaQuestionState {
        return this.value;
      },
    },
  },
  watch: {
    answerText(): void {
      this.modelVar = {
        questionId: this.questionIndex,
        answer: this.answerText,
      };
    },
  },
  methods: {
    validate(): boolean {
      this.isNothingSelected = this.answerText === "";
      return !this.isNothingSelected;
    },
  },
});
